import { isAxiosError } from 'axios'
import { sanitizeBusinessMessage } from './userFacingError'

const CODE_TO_FIELD: Record<string, string> = {
  SLUG_IN_USE: 'slug',
  OWNER_EMAIL_IN_USE: 'email',
  SUBDOMAIN_IN_USE: 'subdomain',
}

const PATH_TO_FIELD: Record<string, string> = {
  name: 'name',
  slug: 'slug',
  email: 'email',
  phone: 'phone',
  country: 'country',
  currency: 'currency',
  businessDescription: 'businessDescription',
  sellingSummary: 'sellingSummary',
  contactStreet: 'contactStreet',
  contactPostcode: 'contactPostcode',
  contactRegion: 'contactRegion',
  contactCountry: 'contactCountry',
  'owner.firstName': 'ownerName',
  'owner.lastName': 'ownerName',
  'storefront.storeName': 'storefrontStoreName',
  'storefront.logoUrl': 'logo',
}

function pathToField(path: unknown): string | null {
  if (Array.isArray(path)) {
    const joined = path.map(String).join('.')
    return PATH_TO_FIELD[joined] ?? joined
  }
  if (typeof path === 'string' && PATH_TO_FIELD[path]) return PATH_TO_FIELD[path]
  return null
}

function getErrorCode(err: unknown): string | undefined {
  if (!isAxiosError(err) || !err.response?.data) return undefined
  const raw = err.response.data as { error?: { code?: string } | unknown }
  if (raw.error && typeof raw.error === 'object' && raw.error !== null && 'code' in raw.error) {
    const code = (raw.error as { code?: string }).code
    return typeof code === 'string' ? code : undefined
  }
  return undefined
}

export function parseApiFieldErrors(err: unknown, fallbackMessage = 'Invalid value'): Record<string, string> {
  const fields: Record<string, string> = {}
  if (!isAxiosError(err) || !err.response?.data) return fields

  const data = err.response.data as { message?: string; error?: unknown }
  const summary = sanitizeBusinessMessage(data.message, fallbackMessage)
  const code = getErrorCode(err)

  if (code && CODE_TO_FIELD[code]) {
    fields[CODE_TO_FIELD[code]] = summary
  }

  const payload = data.error
  if (Array.isArray(payload)) {
    for (const item of payload) {
      if (!item || typeof item !== 'object') continue
      const rec = item as { path?: unknown; message?: unknown }
      const key = pathToField(rec.path)
      if (!key) continue
      fields[key] = sanitizeBusinessMessage(rec.message, 'Invalid value')
    }
  }

  return fields
}
